<div id="forge-editor-holder">
  <div id="floater">
    <div id="clicked-elems-holder">
      <div id="clicked-elems"></div>
    </div>
  </div>
</div>
